export default {
    show_modal: false,
    show_scheduler_modal: false,
    show_scheduler_edit_modal: false,
    edit_scheduler_id: null,
    name: '',
    query: 'Single',
    create_cohort: false,
    notification: false,
    loadings: [],
    message: null,
    analyses_types: [
        {
            all_analysis_types: [],
            analysis_type: ''
        },
        {
            all_analysis_types: [],
            analysis_type: ''
        }
    ],
    datasets: [
        {
            cohorts: {
                all: [],
                copy: [],
                selected: '',
                search: '',
            },
            signal_providers: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            segments: {
                all: [],
                copy: [],
                selected: [],
                search: ''

            },
            categories: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            brands: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            locations: {
                all: [],
                copy: [],
                selected: [],
                search: '',
                all_ids: [],
                ids: '',
                concatenated: [],
                insert_custom: false
            },
            apps_categories: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_tags: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_os: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_names: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_bundleids: {
                all: [],
                copy: [],
                selected: [],
                search: '',
                all_ids: [],
                ids: '',
                concatenated: [],
                insert_custom: false
            },
            countries: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            states: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            dmas: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            cities: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            zip_codes: '',
            competitors: {
                categories: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                brands: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                locations: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                distance: 4,
                unit: 'miles',
            },
            recency: {
                start_date: '',
                end_date: '',
            },
            limits: {
                status: false,
                time: {
                    status: false,
                    limits: [0, 23]
                },
                distance: {
                    status: false,
                    limit: 0.1,
                    unit: 'miles'
                }
            },
            anonymized_fields: [],
            anonymized: {
                geoLocation: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                advertising: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                userDetails: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                ipDetails: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                privacy: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
            }
        },
        {
            cohorts: {
                all: [],
                copy: [],
                selected: '',
                search: '',
            },
            signal_providers: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            segments: {
                all: [],
                copy: [],
                selected: [],
                search: ''

            },
            categories: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            brands: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            locations: {
                all: [],
                copy: [],
                selected: [],
                search: '',
                all_ids: [],
                ids: '',
                concatenated: [],
                insert_custom: false
            },
            apps_categories: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_tags: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_os: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_names: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            apps_bundleids: {
                all: [],
                copy: [],
                selected: [],
                search: '',
                all_ids: [],
                ids: '',
                concatenated: [],
                insert_custom: false
            },
            countries: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            states: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            dmas: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            cities: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            zip_codes: '',
            competitors: {
                categories: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                brands: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                locations: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: '',
                    all_ids: [],
                    ids: '',
                    concatenated: [],
                    insert_custom: false
                },
                distance: 4,
                unit: 'miles',
            },
            recency: {
                start_date: '',
                end_date: '',
            },
            limits: {
                status: false,
                time: {
                    status: false,
                    limits: [0, 23]
                },
                distance: {
                    status: false,
                    limit: 0.1,
                    unit: 'miles'
                }
            },
            anonymized_fields: [],
            anonymized: {
                geoLocation: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                advertising: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                userDetails: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                ipDetails: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
                privacy: {
                    all: [],
                    copy: [],
                    selected: [],
                    search: ''
                },
            }
        }
    ],
    filters: {
        all: [],
        selected: ["anomalous_devices", "anomalous_pois"],
    },
    analyses: {
        audience: {
            status: true
        },
        cross_visitation: {
            status: false,
            poi_location_level: false,
            categories: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            brands: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            locations: {
                all: [],
                copy: [],
                selected: [],
                search: '',
                all_ids: [],
                ids: '',
                concatenated: [],
                insert_custom: false
            },
            countries: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            states: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            dmas: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            cities: {
                all: [],
                copy: [],
                selected: [],
                search: ''
            },
            zip_codes: '',
            recency: {
                start_date: '',
                end_date: '',
            },
            limits: {
                status: false,
                time: {
                    status: false,
                    limits: [0, 23]
                },
                distance: {
                    status: false,
                    limit: 0.1,
                    unit: 'miles'
                }
            },
            filters: {
                all: [],
                selected: ["anomalous_devices", "anomalous_pois"],
            },
        },
        frequency: {
            status: false,
            day_part: false,
        },
        distance: {
            status: false
        }
    },
    scheduler: {
        step: 1,
        message: null,
        audience_type: null,
        audiences: [],
        selected_audience_id: null,
        start_date: '',
        end_date: '',
        time: '',
        full_time: '',
        act_frequency: 'monthly',
        recurrence_type: 2,
        ending_type: 1,
        period: 30,
        ending_after_recurrences: 1,
        auto_activate: false,
        time_zone: ''
    }
}